import type { RoleFitRow } from './computePairFit';

function escapeCsvCell(s: string): string {
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function buildRoleFitMatrixCsv(rows: RoleFitRow[]): string {
  const headers = [
    'candidate_name',
    'candidate_email',
    'current_title',
    'current_company',
    'location',
    'source_channel',
    'skills',
    'resume_uploaded',
    'fitment',
    'coverage_pct',
    'ats_score',
    'ats_rating',
    'job_title',
    'client',
    'gaps_missing_count',
  ];
  const lines = [
    headers.join(','),
    ...rows.map((r) =>
      [
        escapeCsvCell(r.candidate.full_name ?? ''),
        escapeCsvCell(r.candidate.email ?? ''),
        escapeCsvCell(r.candidate.current_title ?? ''),
        escapeCsvCell(r.candidate.current_company ?? ''),
        escapeCsvCell(r.candidate.location ?? ''),
        escapeCsvCell(String(r.candidate.source_channel ?? '')),
        escapeCsvCell((r.candidate.parsed_skills ?? []).join('; ')),
        r.candidate.base_resume_url ? 'yes' : 'no',
        r.fitmentScore,
        r.coverageScore,
        r.atsOverall,
        r.atsRating,
        escapeCsvCell(r.job.title ?? ''),
        escapeCsvCell(r.job.client?.name ?? ''),
        r.gap.missingSkills.length,
      ].join(','),
    ),
  ];
  return lines.join('\n');
}
